import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactsService } from 'src/app/services/contacts.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivityService } from 'src/app/services/activity.service';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {

  addUserFormGroup: FormGroup;
  formSubmitted: boolean = false;
  addUserContact: any;
  filterCountryCode: string;
  countryCodes: any[] = [];
  filterCountryCodesInTable: any[] = [];
  roles:any[]=[];

  // Default payload
  payload = {
    contactName: 'Dharam',
    specalityId: 0,
    emailId: 'dharam.kumar@quadone.com',
    countryCode: '+91',
    mobileNo: '8923727779',
    isFrom: 1,
    callLogId: 0
  };

  constructor(
    private fb: FormBuilder,
    private contactsService: ContactsService,
    private commonService: CommonService,
     private activityService: ActivityService

  ) {
    this.addUserFormGroup = this.fb.group({
      contactName: [''],
      mobileNo: ['', [Validators.required, Validators.pattern('[6-9][0-9]{9}')]],
      emailId: ['', [Validators.required, Validators.email]],
      countryCode: ['', Validators.required],
      role: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.getAllCountryCodes();

  }

  getAllRoles() {
      this.roles = [];
  //    this.loadingFlag = true;
      this.activityService.getAllActivityRoles().pipe(delay(0)).subscribe((res:any) => {
        try {
          this.roles = res;
        } catch (e) {
          console.log('Activities -> Get All Roles => ', e.message)
        }
        //this.loadingFlag = false;
      }, error => {
       // this.loadingFlag = false;
      });
    }
  getAllCountryCodes(): void {
    this.commonService.getCountryCodes().subscribe((res: any) => {
      this.filterCountryCodesInTable.push({ label: "All", value: -1 });
      for (let key in res) {
        res[key].calling_code = "+" + res[key].calling_code;
        this.countryCodes.push(res[key]);
        let temp = { label: res[key].name + ' (' + res[key].calling_code + ')', value: res[key].calling_code };
        this.filterCountryCodesInTable.push(temp);
      }
      this.filterCountryCode = "-1";
    });
  }

  // Submit the form and call the API
  createContact(): void {
    this.formSubmitted = true;
    if (this.addUserFormGroup.valid) {
      this.contactsService.createContact(this.payload).subscribe(
        (res) => {
          console.log('Contact created successfully:', res);
          this.addUserContact = res;  // Store the response for display
        },
        (error) => {
          console.error('Error:', error);
        }
      );
    } else {
      console.log('Form is invalid');
    }
  }

  // // Helper function to check form control errors
  // isControlHasError(controlName: string, errorName: string): boolean {
  //   const control = this.addUserFormGroup.get(controlName);
  //   return control?.hasError(errorName) && control?.touched;
  // }
}
